import { Box, Typography } from "@mui/material";
import { useSnackbar } from "notistack";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import configUrls from "../../config/configUrls";
import { ISprocesso, Processo } from "../../types/processo/Processo";
import { useGetProcessoQuery } from "./processoApiSlice";

import { useDispatch } from "react-redux";
import { setSliceMenuProcessoSelecionado } from "../../components/header/headerSlicer";
import { ProcessoFormViewMenu } from "./ProcessoFormViewMenu";
import "./processoFormViewStyle.css";
import { setNullProcessoSelecioadoSlice, setProcessoSelecioadoSlice } from "./processoSelecionadoSlice";




export const ProcessoFormView = () => {


    const { enqueueSnackbar, closeSnackbar } = useSnackbar()
    const navigate = useNavigate();

    const [processo, setProcesso] = useState<Processo>(ISprocesso);
    const idProcesso = useParams().id_procedimento || "";

    const { data, isFetching, error } = useGetProcessoQuery(idProcesso);

    //pegar o redux
    const dispatch = useDispatch();
    const setMenuProcessoSelecionado = (value: boolean) => {
        dispatch(setSliceMenuProcessoSelecionado(value));
    }


    useEffect(() => {
        if (data) {
            setProcesso(data);
            setMenuProcessoSelecionado(true);
            dispatch(setProcessoSelecioadoSlice(data));

        } else if (error) {
            enqueueSnackbar("Registro não encontrado!", { variant: "error" })
            setMenuProcessoSelecionado(false);
            navigate(configUrls.PROCESSO_LIST_RT)
            dispatch(setNullProcessoSelecioadoSlice());

        } else if (isFetching) {
            enqueueSnackbar("Buscando registro...", { variant: "info" })
        } else {
            enqueueSnackbar("Registro não encontrado!", { variant: "error" })
            setMenuProcessoSelecionado(false);
            dispatch(setNullProcessoSelecioadoSlice());
            navigate(configUrls.PROCESSO_LIST_RT)
        }
    }, [data, error, isFetching])








    return (

        <>
            <Box mt={0} p={0} sx={{ width: "100%" }}>
                <Box p={2}>
                    <Box>
                        <ProcessoFormViewMenu />
                    </Box>

                    <Typography variant="h6" component="h1" sx={{ padding: 2 }}>
                        {processo.numeroProcesso}

                    </Typography>
                </Box>
            </Box>
        </>

    );

};
